<template>
  <main class="banobagi-close" data-test="banobagi-close-page">
    <section
      class="banobagi-close__card"
      aria-labelledby="banobagi-close-title"
      data-test="banobagi-close-content"
    >
      <span class="banobagi-close__badge" aria-hidden="true">
        <svg viewBox="0 0 24 24" class="banobagi-close__icon">
          <path
            d="M12 20.5s-7.5-4.4-7.5-10.1A4.4 4.4 0 0 1 12 7.6a4.4 4.4 0 0 1 7.5 2.8c0 5.7-7.5 10.1-7.5 10.1Z"
          />
        </svg>
      </span>

      <p class="banobagi-close__brand" data-test="banobagi-close-brand">
        BANOBAGI
      </p>

      <h1
        id="banobagi-close-title"
        class="banobagi-close__title"
        data-test="banobagi-close-title"
      >
        {{ title }}
      </h1>

      <div class="banobagi-close__divider" aria-hidden="true">
        <span></span>
      </div>

      <p class="banobagi-close__message" data-test="banobagi-close-message">
        {{ message }}
      </p>

      <p
        v-if="status"
        class="banobagi-close__status"
        data-test="banobagi-close-status"
      >
        {{ status }}
      </p>
    </section>
  </main>
</template>

<script>
// ข้อความ default ของหน้าปิดกิจกรรม (ไม่ได้ตั้งค่าผ่าน Admin)
const CLOSED_COPY = {
  th: {
    title: "ขอบคุณที่ร่วมเป็นส่วนหนึ่งของกิจกรรม",
    message:
      "กิจกรรมสะสมใบเสร็จได้สิ้นสุดลงแล้ว ขอบคุณที่ร่วมสนุกกับ BANOBAGI แล้วพบกันใหม่ในกิจกรรมครั้งถัดไป"
  },
  en: {
    title: "Thank you for joining our campaign",
    message:
      "The receipt campaign has ended. Thank you for celebrating with BANOBAGI — see you in our next campaign."
  }
};

export default {
  name: "BanobagiClose",
  computed: {
    copy() {
      // language id 1 = ไทย (ใช้เกณฑ์เดียวกับ services/font.js)
      const langId = this.$cookies.get("lang")?.lang;
      const isThai = langId == 1 || langId == null;
      return isThai ? CLOSED_COPY.th : CLOSED_COPY.en;
    },
    title() {
      return this.$t("banobagi_closed_title") || this.copy.title;
    },
    message() {
      return this.copy.message;
    },
    status() {
      return this.$t("receipt_campaign_expired");
    }
  }
};
</script>

<style scoped>
.banobagi-close {
  position: relative;
  display: grid;
  min-height: 100dvh;
  place-items: center;
  padding: max(32px, env(safe-area-inset-top)) 16px
    max(32px, env(safe-area-inset-bottom));
  background-color: var(--secondary-color);
  background-image: var(--theme-background-image);
  background-position: center;
  background-size: cover;
  color: var(--text-color);
  text-align: center;
}

.banobagi-close__card {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  align-items: center;
  padding: 48px 28px 32px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.42);
  box-shadow: 0 16px 38px rgba(91, 71, 95, 0.2);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  animation: banobagi-close-rise 600ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

.banobagi-close__badge {
  position: absolute;
  top: -28px;
  left: 50%;
  display: inline-flex;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.76);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 8px 20px rgba(83, 66, 99, 0.14);
  color: var(--primary-color);
  transform: translateX(-50%);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.banobagi-close__icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.banobagi-close__brand {
  margin: 0 0 16px;
  color: var(--primary-color);
  font-size: var(--font-body);
  font-weight: 600;
  letter-spacing: 0.24em;
  /* letter-spacing เพิ่มระยะท้ายตัวสุดท้าย ชดเชยให้กึ่งกลางพอดี */
  padding-left: 0.24em;
}

.banobagi-close__title {
  margin: 0;
  font-size: var(--font-title);
  font-weight: 600;
  line-height: 1.5;
  overflow-wrap: anywhere;
  text-wrap: balance;
}

.banobagi-close__divider {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 20px 0;
}

.banobagi-close__divider::before,
.banobagi-close__divider::after {
  width: 32px;
  height: 1px;
  background: var(--primary-color);
  content: "";
  opacity: 0.5;
}

.banobagi-close__divider span {
  width: 6px;
  height: 6px;
  background: var(--primary-color);
  transform: rotate(45deg);
}

.banobagi-close__message {
  margin: 0;
  font-size: var(--font-body);
  line-height: 1.7;
  overflow-wrap: anywhere;
  text-wrap: pretty;
}

.banobagi-close__status {
  margin: 24px 0 0;
  padding: 6px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.6);
  color: var(--primary-color);
  font-size: var(--font-helper);
  font-weight: 500;
}

@keyframes banobagi-close-rise {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .banobagi-close__card {
    animation: none;
  }
}
</style>
